// credentials: "...."
// is_user: true
// user_email: "mike@biodigital.com"
// user_is_developer: false
// user_is_developer_active: false
// user_is_developer_verified: false
// user_is_third_party: false
// user_third_party_provider: "Google"



export class ProfileCheckModel {
    credentials: string;
    email: string;

    isUser: boolean;
    isThirdParty: boolean;
    isDeveloper: boolean;
    isDeveloperActive: boolean;
    isDeveloperVerified: boolean;

    firstName: string;
    lastName: string;
    name: string;

    thirdPartyProvider: 'Google' | 'Facebook' | '';
    
    static fromJSON(json: any) {
        const profile = new ProfileCheckModel();

        profile.email = json.user_email;
        profile.credentials = json.credentials;
        profile.isUser = json.is_user;
        profile.isThirdParty = json.user_is_third_party;
        profile.thirdPartyProvider = json.user_third_party_provider;
        profile.isDeveloper = json.user_is_developer;
        profile.isDeveloperActive = json.user_is_developer_active;
        profile.isDeveloperVerified = json.user_is_developer_verified;

        profile.firstName = json.user_first_name;
        profile.lastName = json.user_last_name;
        profile.name = `${json.firstName} ${json.lastName}`;

        return profile;
    }
}
